import React from 'react'
import NotificationTable from './components/NotificationTable'

export const Notification = () => {
  return (
    <>
      <div className="h-auto px-3 -mt-24 md:px-8">
        <div className="container max-w-full mx-auto">
          <div className="px-4 mb-16 grid grid-cols-1">
            <NotificationTable />
          </div>
        </div>
      </div>
    </>
  )
}

export default Notification
